import React from 'react'
import { useTranslation } from 'react-i18next'
import { Button, EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/SimpleLottie'
import { ExternalLink } from 'components/ExternalLink/ExternalLink'
import { useMappedRoles } from 'hooks/useMappedRoles'
import { useTwoFAContext } from 'hooks/useTwoFAContext'

interface ApiKeysNoDataProps {
  onSheetOpen: () => void
}

const ApiKeysNoData = ({ onSheetOpen }: ApiKeysNoDataProps) => {
  const { t } = useTranslation()
  const { twoFactorEnabled } = useTwoFAContext()
  const permissions = useMappedRoles().manageApiIntegration
  const canEdit = permissions?.canEdit

  return (
    <EmptyState
      testId="empty-state"
      LottiePlayer={<Lottie src="no-data" />}
      title={t('manageApiKeys.emptyStateNoApiKey')}
      description={
        <>
          {twoFactorEnabled
            ? t('manageApiKeys.emptyStateNoAPIKeysNotice')
            : t('manageApiKeys.twoFADisabled')}{' '}
          <ExternalLink href={process.env.API_KEYS_LEARN}>{t('learnMore')}</ExternalLink>
        </>
      }
      PrimaryButton={
        canEdit &&
        twoFactorEnabled && <Button onClick={onSheetOpen}>{t('manageApiKeys.generateKey')}</Button>
      }
    />
  )
}

export default ApiKeysNoData
